import { useIsFuture } from '@b-stock/fe-core/bstock-react'

import { parseCustomDate } from '@/helpers/dateUtils'
import type { SearchResult } from '@/queries/listingSearchQuery'

const useBuyNowEndTimeIfActive = (listing: SearchResult) => {
  const now = new Date() // oxlint-disable-line react/purity
  const buyNowEndTime =
    listing.buyNow &&
    listing.buyNowEndTime &&
    parseCustomDate(listing.buyNowEndTime) > now
      ? parseCustomDate(listing.buyNowEndTime)
      : null
  const isBuyNow = useIsFuture(buyNowEndTime)

  return isBuyNow ? buyNowEndTime : null
}

export default useBuyNowEndTimeIfActive
